const envUrl = process.env.REACT_APP_BACKEND_URL;

// The backend is always reachable under /api on the host that serves the frontend.
// If the configured URL points to another host (e.g. a custom domain whose DNS is not ready yet),
// fall back to the current origin so the site keeps working.
export const BACKEND_URL = (() => {
  try {
    const origin = window.location.origin;
    return new URL(envUrl).origin !== origin && !origin.includes("localhost") ? origin : envUrl;
  } catch {
    return envUrl;
  }
})();
